var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m9 6h13c0.8 0 1.5 0.7 1.5 1.5v30.5h-16v-30.5c0-0.8 0.7-1.5 1.5-1.5z",
  fill: "#c7d3dc"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 9.8,
  y: 8.5,
  width: 11.4,
  height: 29.5,
  fill: "#5a7d9a"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.8,
  y: 11,
  width: 7.4,
  height: 9,
  rx: 0.9,
  fill: "#6e91ad"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 24,
  r: 1.2,
  fill: "#3f4a54"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(38 31 22)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 7,
  width: 4.4,
  height: 9.5,
  rx: 2,
  fill: "#e0704f"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.6,
  y: 16.5,
  width: 1.4,
  height: 12.5,
  fill: "#8f9ba3"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.3,
  y: 28.6,
  width: 2,
  height: 2.8,
  rx: 0.5,
  fill: "#8f9ba3"
}));

function SvgDoorRepairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorRepairs);
export default __webpack_public_path__ + "static/media/door-repairs.9d00d6591f988616a79f50378165a5c8.svg";
export { ForwardRef as ReactComponent };